import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useRef, useState } from "react";
import { Form, Input, Modal } from "antd";
import HelpLabel from "../../../components/HelpLabel";
import CommunicationCategoryType from "../../../enums/CommunicationCategoryType";
import TenantEmailSettingsResource from "../../../api/tenant/TenantEmailSettingsResource";
import { axiosErrorHandler } from "../../../../../swzutils";
const EmailSenderModal = (props) => {
    const [loading, setLoading] = useState(false);
    const formRef = useRef(null);
    const handleSubmit = (values) => {
        setLoading(true);
        TenantEmailSettingsResource.updateEmailSender(props.tenantId, props.communicationCategory, {
            fromName: values.fromName,
            replyToName: values.replyToName,
            replyToAddress: values.replyToAddress
        }, props.onUpdated, axiosErrorHandler, () => {
            setLoading(false);
        });
    };
    return (_jsx(Modal, { open: props.open, onCancel: props.onCancel, onOk: () => formRef.current?.submit(), confirmLoading: loading, destroyOnHidden: true, title: "Edit", children: _jsxs(Form, { layout: "vertical", onFinish: handleSubmit, ref: formRef, children: [_jsx(Form.Item, { name: "fromName", initialValue: props.sender?.fromName, label: _jsx(HelpLabel, { title: "From Name", helpText: "The name here will appear in the POD email as to who it came from" }), rules: [
                        {
                            required: true,
                            message: 'Please input a name that email message will be addressed from.'
                        }
                    ], children: _jsx(Input, { type: "text" }) }), _jsx(Form.Item, { name: "replyToName", initialValue: props.sender?.replyToName, label: _jsx(HelpLabel, { title: "Reply to Name", helpText: "This determines who the reply name is" }), rules: [
                        {
                            required: true,
                            message: 'Please input a name that email message will reply to.'
                        }
                    ], children: _jsx(Input, { type: "text" }) }), _jsx(Form.Item, { name: "replyToAddress", initialValue: props.sender?.replyToAddress, label: _jsx(HelpLabel, { title: "Reply to Email", helpText: "This field determines who the reply email address goes to" }), rules: [
                        {
                            required: true,
                            message: 'Please input a email address that email message reply to.'
                        }
                    ], children: _jsx(Input, { type: "email" }) })] }) }));
};
export default EmailSenderModal;
